import { render, staticRenderFns } from "./MenuTypeBackOffice.vue?vue&type=template&id=068b765e&scoped=true"
import script from "./MenuTypeBackOffice.vue?vue&type=script&lang=js"
export * from "./MenuTypeBackOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b765e",
  null
  
)

export default component.exports